import type {GradientPalette} from '../types';
import {PALETTE_ID} from '../types';

export default {
    id: PALETTE_ID.EMERALD_20,
    scheme: [
        '#C2EEBA',
        '#AEEAAA',
        '#99E69A',
        '#89E192',
        '#79DD8B',
        '#68D986',
        '#58D583',
        '#48D183',
        '#37CD84',
        '#30C086',
        '#2EB887',
        '#2CAF88',
        '#2AA788',
        '#289F87',
        '#269786',
        '#248F84',
        '#228782',
        '#207E7E',
        '#1E7276',
        '#1C666E',
    ],
    gradient: true,
} as GradientPalette;
